import { render } from "./Inbois.vue?vue&type=template&id=34ae6592"
import script from "./Inbois.vue?vue&type=script&lang=js"
export * from "./Inbois.vue?vue&type=script&lang=js"

import "./Inbois.vue?vue&type=style&index=0&id=34ae6592&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__